module.exports = __webpack_public_path__ + "img/gala-situation.cce9a510.svg";